import { RootState } from 'editor/src/store/index';

const getProducts = (state: RootState) => state.variants.products;

export default getProducts;
